export const config = {
  apiUrl: 'https://api.alberguesyrefugios.com',
}
export const calendar = {
  limitDateRanges: 5,
  formatDate: 'dd-mm-yyyy',
  iconArrowTop:false,
  iconCalendar:'',
  numCalendar:2
}
export const payTime = {
  minutes: 15,
  seconds: 0
}

export const errorOptions = {
  "closeButton": true,
  "debug": false,
  "newestOnTop": false,
  "progressBar": false,
  "positionClass": "toast-top-center",
  "preventDuplicates": true,
  "onclick": null,
  "showDuration": "300",
  "hideDuration": "1000",
  "timeOut": "5000",
  "extendedTimeOut": "1000",
  "showEasing": "swing",
  "hideEasing": "linear",
  "showMethod": "fadeIn",
  "hideMethod": "fadeOut"
};
export const langChange = {
  es: 'Idioma establecido como Español',
  en: 'Language established to English',
  fr: 'Langue établie au français',
  ca: 'Idioma establert com a Català'
};

export const recaptcha = {
  url : 'https://www.google.com/recaptcha/api/siteverify',
  sitekey: '6LdpaNopAAAAAM3d6kV-a2Xui0yffZjBMyk0ICAR',
  privatekey: '6LdpaNopAAAAAJJtFKo4tE0FmEugH2rsSLTNQ0gB',
}

export const turnstile = {
  url: 'https://challenges.cloudflare.com/turnstile/v0/siteverify',
  sitekey: '0x4AAAAAAAhI9qjyabiiS_PH',
  privatekey: '0x4AAAAAAAhI9oHEZMo6oRFdyRdvGtLcgEg'
}


// WEBPACK FOOTER //
// ./src/_config/app.config.js